import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import axios from "axios";
import { PROFILE } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const YT_LOGO = "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/holj0k53_YouTube_Logo_2017-1.svg.png";

export const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/youtube/videos?max_results=6`)
      .then((res) => setVideos(res.data.videos || []))
      .catch((e) => console.error("videos fetch failed", e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="videos" data-testid="videos" className="bg-[#FF0000] py-20 md:py-32 px-5 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 md:mb-16">
          <div>
            <h2 className="font-anton uppercase text-5xl md:text-7xl leading-none text-white">
              Latest videos
            </h2>
            <div className="flex items-center flex-wrap gap-x-3 gap-y-2 mt-5">
              <span className="font-anton uppercase text-white text-2xl md:text-4xl">I love making</span>
              <span className="inline-flex items-center bg-white rounded-xl px-3 py-1.5 shadow-lg">
                <img src={YT_LOGO} alt="YouTube" className="h-6 md:h-8 w-auto" />
              </span>
              <span className="font-anton uppercase text-white text-2xl md:text-4xl">videos</span>
            </div>
          </div>
          <motion.a
            data-testid="videos-channel-link"
            href={PROFILE.youtube}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05, rotate: -2 }}
            whileTap={{ scale: 0.95 }}
            className="font-outfit font-extrabold text-sm uppercase tracking-wide bg-white text-[#FF0000] px-6 py-3 rounded-full w-max shadow-lg"
          >
            Subscribe on YouTube →
          </motion.a>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-video bg-white/20 animate-pulse rounded-2xl" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((v, i) => (
              <motion.a
                key={v.video_id}
                href={v.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`video-card-${i}`}
                initial={{ opacity: 0, y: 40, rotate: i % 2 ? 2 : -2 }}
                whileInView={{ opacity: 1, y: 0, rotate: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ type: "spring", stiffness: 110, damping: 13, delay: (i % 3) * 0.08 }}
                whileHover={{ y: -8 }}
                className="group block"
              >
                <div className="relative aspect-video overflow-hidden rounded-2xl border-4 border-white bg-obsidian shadow-xl">
                  <img
                    src={v.thumbnail}
                    alt={v.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-16 h-16 rounded-full bg-white text-[#FF0000] flex items-center justify-center scale-90 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <Play size={26} fill="currentColor" className="ml-1" />
                    </span>
                  </div>
                </div>
                <h3 className="font-outfit font-bold text-white mt-4 text-lg leading-snug line-clamp-2">
                  {v.title}
                </h3>
              </motion.a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
